import { FC } from "react";
import isEmail from "validator/lib/isEmail";

interface EmailProps {
  value?: string | null;
}

const Email: FC<EmailProps> = ({ value }: EmailProps) => {
  if (!value || !isEmail(value)) {
    return <>{value}</>;
  }
  return (
    <>
      {value && (
        <a href={`mailto:${value}`} onClick={(event) => event.stopPropagation()}>
          {value}
        </a>
      )}
    </>
  );
};

export default Email;
